<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1"><a href="#/Text/4start#chap1">Chapter 1</a></p>
<p class="toc1"><a href="#/Text/5chap2#chap2">Chapter 2</a></p>
<p class="toc1"><a href="#/Text/6chap3#chap3">Chapter 3</a></p>
<p class="toc1"><a href="#/Text/7chap4#chap4">Chapter 4</a></p>
<p class="toc1"><a href="#/Text/8chap5#chap5">Chapter 5</a></p>
<p class="toc1"><span href="#/Text/9chap6#chap6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc1"><span href="#/Text/10chap7#chap7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc1"><span href="#/Text/11chap8#chap8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc1"><span href="#/Text/12chap9#chap9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc1"><span href="#/Text/13chap10#chap10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc1"><span href="#/Text/14chap11#chap11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc1"><span href="#/Text/15chap12#chap12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc1"><span href="#/Text/16chap13#chap13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc1"><span href="#/Text/17chap14#chap14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc1"><span href="#/Text/18chap15#chap15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc1"><span href="#/Text/19chap16#chap16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc1"><span href="#/Text/20chap17#chap17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc1"><span href="#/Text/21chap18#chap18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc1"><span href="#/Text/22chap19#chap19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc1"><span href="#/Text/23chap20#chap20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="toc1"><span href="#/Text/24chap21#chap21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="toc1"><span href="#/Text/25chap22#chap22" title="Link target outside of Sample">Chapter 22</span></p>
<p class="toc1"><span href="#/Text/26chap23#chap23" title="Link target outside of Sample">Chapter 23</span></p>
<p class="toc1"><span href="#/Text/27chap24#chap24" title="Link target outside of Sample">Chapter 24</span></p>
<p class="toc1"><span href="#/Text/28chap25#chap25" title="Link target outside of Sample">Chapter 25</span></p>
<p class="toc1"><span href="#/Text/29chap26#chap26" title="Link target outside of Sample">Chapter 26</span></p>
<p class="toc1"><span href="#/Text/30chap27#chap27" title="Link target outside of Sample">Chapter 27</span></p>
<p class="toc1"><span href="#/Text/31chap28#chap28" title="Link target outside of Sample">Chapter 28</span></p>
<p class="toc1"><span href="#/Text/32chap29#chap29" title="Link target outside of Sample">Chapter 29</span></p>
<p class="toc1"><span href="#/Text/33chap30#chap30" title="Link target outside of Sample">Chapter 30</span></p>
<p class="toc1"><span href="#/Text/34chap31#chap31" title="Link target outside of Sample">Chapter 31</span></p>
<p class="toc1"><span href="#/Text/35chap32#chap32" title="Link target outside of Sample">Chapter 32</span></p>
<p class="toc1"><span href="#/Text/36chap33#chap33" title="Link target outside of Sample">Chapter 33</span></p>
<p class="toc1"><span href="#/Text/37chap34#chap34" title="Link target outside of Sample">Chapter 34</span></p>
<p class="toc1"><span href="#/Text/38chap35#chap35" title="Link target outside of Sample">Chapter 35</span></p>
<p class="toc1"><span href="#/Text/39chap36#chap36" title="Link target outside of Sample">Chapter 36</span></p>
<p class="toc1"><span href="#/Text/40chap37#chap37" title="Link target outside of Sample">Chapter 37</span></p>
<p class="toc1"><span href="#/Text/41chap38#chap38" title="Link target outside of Sample">Chapter 38</span></p>
<p class="toc1"><span href="#/Text/42chap39#chap39" title="Link target outside of Sample">Chapter 39</span></p>
<p class="toc1"><span href="#/Text/43chap40#chap40" title="Link target outside of Sample">Chapter 40</span></p>
<p class="toc1"><span href="#/Text/44chap41#chap41" title="Link target outside of Sample">Chapter 41</span></p>
<p class="toc1"><span href="#/Text/45chap42#chap42" title="Link target outside of Sample">Chapter 42</span></p>
<p class="toc1"><span href="#/Text/46chap43#chap43" title="Link target outside of Sample">Chapter 43</span></p>
<p class="toc1"><span href="#/Text/47chap44#chap44" title="Link target outside of Sample">Chapter 44</span></p>
<p class="toc1"><span href="#/Text/48chap45#chap45" title="Link target outside of Sample">Chapter 45</span></p>
<p class="toc1"><span href="#/Text/49chap46#chap46" title="Link target outside of Sample">Chapter 46</span></p>
<p class="toc1"><span href="#/Text/50chap47#chap47" title="Link target outside of Sample">Chapter 47</span></p>
<p class="toc1" style="margin-top:20px;"><span href="#/Text/teaser00" title="Link target outside of Sample">Preview: <i>Dying on the Vine</i></span></p>
<p class="toc1"><span href="#/Text/51ack#ack" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3TOC.vue?517f8688